import React from "react";

import OverlayContext from "./Context";

export const withOverlay = Component => props => (
  <OverlayContext.Consumer>
    {context => <Component {...props} overlay={context} />}
  </OverlayContext.Consumer>
);
